export default "__VITE_ASSET__zykHBRid__"